<template>
  <div class="market-position-screens">
    <div class="container-fluid">
      <div class="row">
        <div class="col-6">
          <img src="@/images/invest/ggl-o-es.png" class="w-100 rounded-3 border shadow-lg" />
        </div>
        <div class="col-6">
          <img src="@/images/invest/ggl-o-it.png" class="w-100 rounded-3 border shadow-lg" />
        </div>
      </div>
    </div>
  </div>
</template>